import React from "react";
import { Container, Row, Col } from "shards-react";
import CreditNote from "../components/invoicing/CreditNote";

const CreditNoteView = props => {
  const { id, invoice_id } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <CreditNote id={id} invoice_id={invoice_id} />
        </Col>
      </Row>
    </Container>
  );
};

export default CreditNoteView;
